import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import PropTypes from 'prop-types'

const successfulColumns = [
  { field: 'CatalogID', headerName: 'Catalog ID', width: 200 },
  { field: 'Currency', headerName: 'Currency', width: 120 },
  { field: 'UnitAmount', headerName: 'Unit Amount', width: 150 },
  { field: 'ListPrice', headerName: 'List Price', width: 150 }
]

const failedColumns = [
  {
    field: 'CatalogID',
    headerName: 'Catalog ID',
    width: 200
  },
  { field: 'Currency', headerName: 'Currency', flex: 1 },
  { field: 'error', headerName: 'Error Reason', flex: 1 }
]

const UploadPriceResponseDialog = ({ open, onClose, responseData }) => {
  if (!responseData || !responseData.data) {
    return null
  }

  const { successfulInsertions, failedInsertions } = responseData.data

  // useEffect(() => {
  //     console.log("failed", failedInsertions, "successful", successfulInsertions);
  // }, [failedInsertions, successfulInsertions]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>CSV Upload Summary</DialogTitle>
      <DialogContent dividers>
        {successfulInsertions && successfulInsertions.length > 0 && (
          <Box mb={4}>
            <Typography variant='h6' gutterBottom color='success.main'>
              ✅ Successful Records ({successfulInsertions.length})
            </Typography>
            <div style={{ height: 300, width: '100%' }}>
              <DataGrid
                rows={successfulInsertions.map((item, index) => ({
                  id: index,
                  ...item
                }))}
                columns={successfulColumns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                getRowId={(row) => row.id}
              />
            </div>
          </Box>
        )}

        {failedInsertions && failedInsertions.length > 0 && (
          <Box>
            <Typography variant='h6' gutterBottom color='error.main'>
              ❌ Failed Records ({failedInsertions.length})
            </Typography>
            <div style={{ height: 300, width: '100%' }}>
              <DataGrid
                rows={failedInsertions.map((item, index) => ({
                  id: index,
                  CatalogID: item.row.CatalogID,
                  Currency: item.row.Currency,
                  UnitAmount: item.row.UnitAmount,
                  ListPrice: item.row.ListPrice,
                  error: item.error
                }))}
                columns={failedColumns}
                pageSize={5}
                rowsPerPageOptions={[5, 10]}
                getRowId={(row) => row.id}
              />
            </div>
          </Box>
        )}

        {successfulInsertions.length === 0 && failedInsertions.length === 0 && (
          <Typography variant='body1' align='center'>
            No records were processed.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary' variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UploadPriceResponseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  responseData: PropTypes.shape({
    data: PropTypes.shape({
      failedInsertions: PropTypes.arrayOf(PropTypes.object),
      successfulInsertions: PropTypes.arrayOf(PropTypes.object)
    })
  })
}

export default UploadPriceResponseDialog
